import React from "react";
import {connect} from "react-redux";
import parse from "html-react-parser";
import sanitizeHtml from "sanitize-html";
import {ModalTypes} from "../../../tools/StaticTypes";
import {API} from "../../../tools/API_NEW/API";
import {store} from "../../../index";
import {DOCUMENT_PREVIEW_ACTIONS} from "../../../store/documents/documentActionsList";
import {addModalData, setModalData} from "../../../store/globalState/actionCreators/globalState_AppActionCreator";
import {PACKAGES_TREE_ACTIONS} from "../../../store/packages/packageActionsList";


class ContentSectionPackages extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen : false,
            updateCounter: 0,
            lastUpdate: null,
        };

        this.toggle = this.toggle.bind(this);
    }

    // открытье\закрытие раздела
    toggle() {
        this.setState({
            isOpen : !this.state.isOpen
        });
    }


    render() {
        if(!this.props.activeDocument) return null;
        let isReady = this.props.activeDocument.additionalSections.isReady;
        let sectionData = this.props.activeDocumentContent;
        let activeFileId = this.props.activeDocument?.preview?.files[this.props.activeDocument?.preview?.activeFileIndex].id;
        if(this.props.activeDocument?.preview?.activeFileIndex){
                activeFileId = this.props.activeDocument?.preview?.files[this.props.activeDocument?.preview?.activeFileIndex].id;
        }

        let cardTitleClass = "card-title";
        let cardCollapseClass = "collapse show";
        if(!this.state.isOpen) {
            cardTitleClass = "card-title collapsed";
            cardCollapseClass = "collapse";
        }

        //TODO:24072-Ошибка по содержанию документа,когда происходит перещелкивание файлов
        let originalSectionData = sectionData;
        if(typeof sectionData==='object'&&!Array.isArray(sectionData) && sectionData !== null){
            sectionData=sectionData.content
        }

        let sectionDataText = sanitizeHtml(sectionData, {
            allowedAttributes: {span: ["class", "className"]}
        });

        return (
            <div className="card" key={`content-section-${this.state.lastUpdate || 'initial'}-${this.state.updateCounter}`}>
                <div className="card-header" onClick={this.toggle}>
                    <div className={cardTitleClass}>
                        Содержание
                    </div>
                </div>
                <div className={cardCollapseClass}>
                    <div className="card-body content-section p-6">
                        {
                            isReady &&
                            <pre className="content-text" key={`content-section-${this.state.updateCounter}`}>{parse(sectionDataText)}</pre>
                        }
                    </div>
                    <div className={'footer d-flex'}>
                        <div title="Изменить содержание"
                             onClick={() => {
                                 if (activeFileId) {
                                     this.props.addModalData({
                                         name: ModalTypes.documents.mainTable.EditContent,
                                         data: {
                                             text: originalSectionData,
                                             docId:activeFileId,
                                             path: 'packages',
                                             callback: async () => {
                                                 this.setState({ updateCounter: this.state.updateCounter + 1 })
                                                 // Принудительно обновляем компонент
                                                 this.forceUpdate();
                                             }
                                         }
                                     })

                                     this.setState({ updateCounter: this.state.updateCounter + 1 })
                                 }
                             }}
                        >
                            <span className={`btn btn-icon btn-sm`}>
                                <i className={`svg-icon icon-Table_edit_1 icon-color-primary`}/>
                            </span>
                        </div>

                        <div title="Пересоздать файл содержания"
                             onClick={async () => {
                                 if (activeFileId) {
                                     await this.props.setModalData({
                                         name: ModalTypes.app.info,
                                         data: {
                                             type: "question",
                                             content: `Вы действительно хотите пересоздать содержание документа?`,
                                             disableButton: false,
                                             fullBackground: false,
                                             onClickContinue: async () => {
                                                 await API.documents().resetDocFileContent({
                                                     id:activeFileId,
                                                     isAvailable: true
                                                 });

                                                 store.dispatch({
                                                     type: PACKAGES_TREE_ACTIONS.UPDATE_CONTENT,
                                                     payload: {contentSection: 'Текст ещё не сгенерирован.'}
                                                 })
                                                 this.setState({ updateCounter: this.state.updateCounter + 1 })
                                                 // Принудительно обновляем компонент
                                                 this.forceUpdate();
                                                 this.props.setModalData({})
                                                 this.props.setModalData({
                                                     name: ModalTypes.app.info,
                                                     data: {type: "success", content: `Содержимое документа успешно изменено`}
                                                 });}
                                         }
                                     });
                                 }
                             }}
                        >
                            <span className={`btn btn-icon btn-sm`}>
                                <i className={`svg-icon icon-Reload icon-color-primary`}/>
                            </span>
                        </div>

                        {/*<div title="Обновить файл содержания"*/}
                        {/*     onClick={async () => {*/}
                        {/*         this.props.addModalData({*/}
                        {/*             name: ModalTypes.documents.updatePreviewFile,*/}
                        {/*             data: {*/}
                        {/*                 activeView: 'content',*/}
                        {/*                 callback: async () => {*/}
                        {/*                     await this.props.collectDataForAdditionalSections_Normal({});*/}
                        {/*                 }*/}
                        {/*             }*/}
                        {/*         });*/}
                        {/*     }}*/}
                        {/*>*/}
                        {/*    <span className={`btn btn-icon btn-sm`}>*/}
                        {/*        <i className={`svg-icon icon-Doc_view_8 icon-color-primary`}/>*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        );
    }
}

const  mapStateToProps = state => {
    return {
        activeDocument : state.packages.tree.activeDocument,
        activeDocumentContent : state.packages.tree?.activeDocument?.additionalSections?.contentSection?.content,
    }
}

const  mapDispatchToProps = {
    setModalData,
    addModalData
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentSectionPackages);
